import { Platform } from 'ionic-angular';

import { Injectable } from '@angular/core';
import { Network } from '@ionic-native/network';

@Injectable()
export class ConnectedProvider {

  connected: boolean = true;

  constructor(public network: Network, private platform: Platform) {
    this.platform.ready().then(() => {
      if (this.platform.is('cordova')) {
        this.network.onConnect().subscribe(() => {
          this.connected = true;
        });

        this.network.onDisconnect().subscribe(() => {
          this.connected = false;
        })
      }
    })


  }

  isConnected(): boolean {
    return this.connected;
  }



}



// WEBPACK FOOTER //
// ./src/providers/connected/connected.ts